module.exports = __webpack_public_path__ + "img/40f.f693ca5f.png";